/**
 * Tree-shaken Swiper bundle
 */
import Swiper, { Navigation, Pagination, EffectFade, A11y } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, A11y]);

(window as Window).Swiper = Swiper;
